export default __webpack_public_path__ + "static/7-0bd5d63b3e7c3cb581ff506ae4b786d0.png";